import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./styles/global.css";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import InstallPrompt from "./components/InstallPrompt";

// Import pages
import Home from "./pages/Home.jsx";
import Auth from "./pages/Auth.jsx";
import Products from "./pages/Products.jsx";
import ProductNis2scan from "./pages/ProductNis2scan.jsx";
import ProductTemplate from "./pages/ProductTemplate.jsx";
import Lab from "./pages/Lab.jsx";
import LabGuideDetail from "./pages/LabGuideDetail.jsx";
import Success from "./pages/Success.jsx";
import Checkout from "./pages/Checkout.jsx";
import About from "./pages/About.jsx";
import Contact from "./pages/Contact.jsx";
import NotFound from "./pages/NotFound.jsx";

/**
 * Main App Component
 * Sets up the router and layout structure
 */
function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <div className="app">
            <Navbar />

            <main className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/auth" element={<Auth />} />
                <Route
                  path="/products/nis2scan"
                  element={<ProductNis2scan />}
                />
                <Route path="/products/:slug" element={<ProductTemplate />} />
                <Route path="/lab" element={<Lab />} />
                <Route path="/lab/:slug" element={<LabGuideDetail />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/success" element={<Success />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>

            <Footer />
            <CookieConsent />
            <InstallPrompt />
          </div>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
